import { ICampaignPrebidInfo } from '~/src/dash/api/campaign/campaign_models';
import { IBidderWithTableData } from '~/src/dash/api/console-api';
import {
  addDomainAndTokenToUrl,
  generateTokenParams,
  IHttpResponse,
  restGet,
} from '~/src/dash/api/rest';
import { getPbsUS } from '~/src/dash/resellers/utils/importResellerConfig';

export async function getCampaignPrebidInfo(
  campaignIDS: string,
  publisherID: string,
): Promise<[ICampaignPrebidInfo[] | undefined, string | undefined]> {
  const reqUrl =
    getPbsUS() +
    '/campaign_list_info?campaign_ids=' +
    campaignIDS +
    '&' +
    generateTokenParams(publisherID);

  try {
    return [(await restGet<ICampaignPrebidInfo[]>(reqUrl, {})).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function getInactiveHeaderBiddersTargetingCampaign(
  campaignID: string,
  publisherID: string,
): Promise<IHttpResponse<IBidderWithTableData[]>> {
  const reqURL = addDomainAndTokenToUrl(
    `/publishers/${publisherID}/campaigns/${campaignID}/inactive_headerbidders_targeting_campaign`,
  );
  return await restGet<IBidderWithTableData[]>(reqURL, {});
}
